// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { router } from './router'
import { Dialog } from 'vant'
Vue.use(Dialog)

//vuex状态管理
import Vuex from 'vuex'
import store from './store/index'

import './assets/css/base.css'
import './assets/css/dynamic.scss'
import './assets/css/common.scss'

import 'font-awesome/css/font-awesome.css'

//自动转换REM
import 'lib-flexible/flexible.js'

//自定义指令
import directive from './directive/index'

//zepto
//import $ from 'jquery'
import $ from './assets/js/jquery.min.js'
// 组件的使用
import components from './components'
Vue.use(components)

//全局方法
import gob from './gob'
Vue.prototype.gob = gob
//校验
import ruler from './utils/ruler'
Vue.prototype.ruler = ruler

Vue.config.productionTip = false

import { NoticeBar } from 'vant'
Vue.use(NoticeBar)
import 'vant/lib/notice-bar/style';

/* eslint-disable no-new */
const app= new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js